export function getBatchStatus (batch, taskSummary) {
  if (!batch) return { label: 'Unknown', className: '', icon: 'help', iconColor: 'gray' }
  if (batch.isError) return { label: 'Failed', className: 'errored', icon: 'close', iconColor: 'red' }
  if (batch.isProcessing) return { label: 'Processing', className: 'processing', icon: 'sync', iconColor: 'var(--color-primary-500)' }
  if (batch.lastFinishedDate) return { label: 'Completed', className: 'complete', icon: 'check', iconColor: 'green' }
  const total = taskSummary?.total ?? batch.taskSummary?.total ?? 0
  if (total > 0) return { label: 'Awaiting Review', className: 'idle', icon: 'hand', iconColor: 'orange' }
  return { label: 'Awaiting Upload', className: 'idle', icon: 'cloudUpload', iconColor: 'gray' }
}
